// extracted by mini-css-extract-plugin
module.exports = {"region":"Region_region__1XG8h"};